'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokCrossSellGridType } from '../../storyblok'
import { StoryblokRecommendationGridRenderer } from '../StoryblokRecommendation/StoryblokRecommendationGridRenderer'

export const StoryblokCrossSellGrid: FC<
  StoryblokComponentProps<StoryblokCrossSellGridType>
> = ({ blok }) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Storyblok content may predate the recommendation field migration.
  if (!blok.areaId || !blok.serviceId) {
    return null
  }

  return (
    <StoryblokRecommendationGridRenderer
      editableProps={storyblokEditable(blok)}
      serviceId={blok.serviceId}
      widgetId={blok.areaId}
    />
  )
}
